var poll_header_default = {
  "title": "_5b1z5",
  "image": "ERw4Y",
  "webview": "Zpf3v"
};
export {
  poll_header_default as default
};
//# sourceMappingURL=poll-header-scss.js.map
